import { unansweredOffers, type UnansweredOffer } from "@/mocks/managerWorkspace";

export default function UnansweredOffersWidget() {
  return (
    <div className="bg-white rounded-lg border border-[#D5CA8A] overflow-hidden h-full flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-[#FEF3C7] border-b border-[#D5CA8A]">
        <div className="flex items-center gap-1.5">
          <i className="ri-file-close-line text-[12px] text-[#DC2626]"></i>
          <span className="text-[11px] font-semibold text-[#2D2D2D]">КП без ответа</span>
        </div>
        <span className="text-[11px] font-bold text-[#DC2626]">{unansweredOffers.length}</span>
      </div>
      <div className="flex-1 overflow-auto">
        <table className="w-full text-[10px]">
          <thead>
            <tr className="bg-[#FDF2B5]/50 text-[#666666]">
              <th className="text-left px-2 py-1 font-medium">Клиент</th>
              <th className="text-left px-2 py-1 font-medium">Документ</th>
              <th className="text-left px-2 py-1 font-medium">Дата</th>
              <th className="text-left px-2 py-1 font-medium">Дней</th>
            </tr>
          </thead>
          <tbody>
            {unansweredOffers.map((o: UnansweredOffer, i: number) => (
              <tr key={i} className="border-b border-[#D5CA8A]/30 hover:bg-[#FDF2B5]/30 transition-colors">
                <td className="px-2 py-1.5 text-[#2D2D2D]">{o.client}</td>
                <td className="px-2 py-1.5 text-[#666666]">{o.document}</td>
                <td className="px-2 py-1.5 text-[#666666]">{o.date}</td>
                <td className="px-2 py-1.5">
                  <span className={`px-1.5 py-0.5 rounded text-[9px] font-medium ${o.days > 14 ? "bg-[#FEE2E2] text-[#DC2626]" : o.days > 7 ? "bg-[#FEF3C7] text-[#D97706]" : "bg-[#D4EDDA] text-[#2D6A4F]"}`}>
                    {o.days} дн
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="px-3 py-1.5 border-t border-[#D5CA8A]">
        <button className="text-[10px] text-[#2D2D2D] hover:bg-[#FDF2B5] px-2 py-0.5 rounded transition-colors cursor-pointer">
          Все КП
        </button>
      </div>
    </div>
  );
}